export default "__VITE_ASSET__3CvIhK0M__"